import React, { useState } from 'react';
import { TrendingUp } from 'lucide-react';

const ProgressView = ({ sessions, exercises }) => {
  const [selectedExercise, setSelectedExercise] = useState(exercises[0]?.id || null);

  const exercise = exercises.find(e => e.id === selectedExercise);
  const exerciseSessions = sessions
    .filter(s => s.exerciseId === selectedExercise)
    .sort((a, b) => new Date(a.date) - new Date(b.date));

  return (
    <div className="bg-slate-800/50 backdrop-blur rounded-xl p-6 shadow-2xl">
      <h2 className="text-2xl font-bold mb-6">Progress Tracking</h2>
      
      <div className="mb-6">
        <label className="block text-sm font-semibold mb-2 text-slate-300">Select Exercise</label>
        <select
          value={selectedExercise || ''}
          onChange={(e) => setSelectedExercise(Number(e.target.value))}
          className="w-full px-4 py-3 bg-slate-700 border border-slate-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        >
          {exercises.map(ex => (
            <option key={ex.id} value={ex.id}>{ex.name}</option>
          ))}
        </select>
      </div>

      {exerciseSessions.length === 0 ? (
        <div className="text-center py-12 text-slate-400">
          <TrendingUp className="w-16 h-16 mx-auto mb-4 opacity-50" />
          <p>No sessions recorded for this exercise yet.</p>
        </div>
      ) : (
        <div className="space-y-4">
          {exerciseSessions.map((session, idx) => (
            <div key={session.id} className="bg-slate-900/50 rounded-lg p-4 border border-slate-700">
              <div className="flex justify-between items-start mb-2">
                <div className="text-sm text-slate-400">{session.date}</div>
                {idx > 0 && (
                  <div className="text-xs text-green-400">
                    Session #{idx + 1}
                  </div>
                )}
              </div>

              {exercise?.type === 'strength' && session.sets && (
                <div className="space-y-2">
                  {session.sets.map((set, setIdx) => (
                    <div key={setIdx} className="flex justify-between items-center bg-slate-800 p-3 rounded">
                      <span className="text-sm text-slate-400">Set {setIdx + 1}</span>
                      <span className="font-semibold">{set.weight} kg × {set.reps} reps</span>
                      {idx > 0 && exerciseSessions[idx - 1].sets?.[setIdx] && (
                        <span className={`text-xs ${
                          set.weight > exerciseSessions[idx - 1].sets[setIdx].weight ||
                          set.reps > exerciseSessions[idx - 1].sets[setIdx].reps
                            ? 'text-green-400'
                            : 'text-slate-500'
                        }`}>
                          {set.weight > exerciseSessions[idx - 1].sets[setIdx].weight && '↑ weight '}
                          {set.reps > exerciseSessions[idx - 1].sets[setIdx].reps && '↑ reps'}
                        </span>
                      )}
                    </div>
                  ))}
                </div>
              )}

              {exercise?.avgSpeedMetric && session.avgSpeed && (
                <div className="flex justify-between items-center bg-slate-800 p-3 rounded">
                  <span className="text-sm text-slate-400">Average Speed</span>
                  <span className="font-semibold">{session.avgSpeed} km/h</span>
                  {idx > 0 && exerciseSessions[idx - 1].avgSpeed && (
                    <span className={`text-xs ${
                      session.avgSpeed > exerciseSessions[idx - 1].avgSpeed
                        ? 'text-green-400'
                        : session.avgSpeed < exerciseSessions[idx - 1].avgSpeed
                        ? 'text-red-400'
                        : 'text-slate-500'
                    }`}>
                      {session.avgSpeed > exerciseSessions[idx - 1].avgSpeed && '↑'}
                      {session.avgSpeed < exerciseSessions[idx - 1].avgSpeed && '↓'}
                      {session.avgSpeed === exerciseSessions[idx - 1].avgSpeed && '→'}
                    </span>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ProgressView;
